import {
    Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress,
    Typography, Box, Grid, Button, FormControlLabel
} from '@material-ui/core';
import { useContext } from 'react';
import { Dropzone, EditIconButton } from 'components';
import { editorContext } from './EditorContext';
import { Formik, Form, Field } from 'formik';
import { DatePicker } from 'formik-material-ui-pickers';
import { TextField, Checkbox } from 'formik-material-ui';
import { Alert } from '@material-ui/lab';


let Editor = () => {
    let service = useContext(editorContext);

    return (
        <>
            <EditIconButton size="medium" onClick={service.open} />

            <Dialog
                open={service.isOpen}
                maxWidth="md"
                fullWidth={true}
                scroll="paper"
            >
                <Formik
                    enableReinitialize={true}
                    validationSchema={service.updateSchema}
                    initialValues={service.updateRequest}
                    onSubmit={(values, action) => {
                        service.updateRegistration(values);
                    }}
                >
                    {form =>
                        <Form>
                            <DialogTitle disableTypography>
                                <Typography variant="h3">
                                    <Box fontWeight="fontWeightLight">Edit registration</Box>
                                </Typography>
                            </DialogTitle>

                            <DialogContent dividers>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <Field
                                            component={DatePicker}
                                            name="purchaseDate"
                                            label="Purchase Date"
                                            variant="inline"
                                            autoOk
                                            inputVariant="outlined"
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            name="serialNumber"
                                            label="Serial Number"
                                            variant="outlined"
                                        />
                                    </Grid>


                                    <Grid item xs>
                                        <FormControlLabel
                                            label="Unlimited warranty"
                                            name="unlimited"
                                            value={form.values.unlimited}
                                            checked={form.values.unlimited}
                                            onChange={(e: any) => form.setFieldValue('unlimited', e.target.checked)}
                                            control={<Field type="checkbox" name="unlimited" component={Checkbox} />}
                                        />
                                    </Grid>
                                    {form.values.unlimited === false &&
                                        <>
                                            <Grid item xs={5}>
                                                <Field
                                                    component={TextField}
                                                    name="extensionMonths"
                                                    label="Extension Months"
                                                    type="number"
                                                    variant="outlined"
                                                />
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Typography>months in addition to {service.legalMonths} months of legal warranty</Typography>
                                            </Grid>
                                        </>
                                    }

                                    {service.receiptUploaded === false &&
                                        <Grid item xs={12}>
                                            <Dropzone
                                                isMultiple={false}
                                                title="Upload receipt"
                                                onDropCallback={async (files: any[]) => await service.uploadReceipt(files[0])}
                                            />
                                            {service.isUploading && <CircularProgress />}
                                            {service.isUploading === false && service.isUploaded &&
                                                <Grid item xs={12}>
                                                    <Typography>Receipt uploaded: <b>{service.updateRequest.receiptFileName}</b></Typography>
                                                </Grid>
                                            }
                                            {service.updateRequest.receiptId &&
                                                <Alert severity="info">
                                                    Once the receipt has been uploaded to the registration, it will no longer be possible to change it
                                                </Alert>
                                            }
                                        </Grid>
                                    }

                                    <Grid item xs={12}>
                                        <Field
                                            component={TextField}
                                            name="reason"
                                            label="Reason"
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <DialogActions>
                                {service.isSaving && <CircularProgress size={24} />}
                                <Button
                                    disabled={service.isSaving}
                                    onClick={service.close}
                                    variant="outlined"
                                    color="secondary"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    color="primary"
                                    disabled={service.isSaving}
                                >
                                    Save
                                </Button>
                            </DialogActions>
                        </Form>
                    }
                </Formik>
            </Dialog>
        </>
    )
}

export default Editor;